import {
   Component,
   Input,
   OnChanges,
   OnDestroy,
   OnInit,
   SimpleChanges,
   Directive,
   Output,
   EventEmitter,
} from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { FirestoreService } from 'src/app/shared/services/firestore.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
// import { LoaderServices } from 'src/app/shared/services/loader.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';
import { TypesenseService } from 'src/app/shared/services/typesense.service';
import { CollectionComplianceService } from 'src/app/shared/services/collection-compliance.service';
import { SubscriptionInfoModel } from 'src/app/models/subscription-info.model';
import { SubscriptionService } from 'src/app/shared/services/subscription.service';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
    selector: 'app-related-stocks',
    templateUrl: './related-stocks.component.html',
    styleUrls: ['./related-stocks.component.scss'],
    standalone: false
})
export class RelatedStocksComponent implements OnInit, OnChanges, OnDestroy {
   private destroy$ = new Subject<void>();
   isMobile: boolean = false;
   public relatedStocks: any[];
   public complianceInfo: any;
   private subscriptions: Subscription[];
   public orderFieldName: string = '';
   public orderDirection: any = true;
   public showRequest: boolean = false;

   @Input() musaffaIndustryName: string | undefined;
   @Input() marketCapClassification: string | undefined;
   @Input() country: string | undefined;
   @Input() gsubind: string | any;
   @Input() ticker: string | any;
   @Input() musaffaSectorName: string | any;
   @Input() complianceStatus!: string;
   @Input() finnhubIndustry!: string;
   @Input() gsector!: string;
   @Input() name!: string;

   public booleanValue: any;
   loader: boolean = false;

   constructor(
      private apiService: ApiService,
      private firestoreService: FirestoreService,
      private collectionCompliance: CollectionComplianceService,
      // private ws: WebsoketService,
      // private loader: LoaderServices,
      private router: Router,
      private auth: AuthService,
      private typesenseService: TypesenseService,
      private observer: BreakpointObserver,
   ) {
      this.relatedStocks = [];
      this.subscriptions = [];
   }

   ngOnInit() {
      this.observer
         .observe('(max-width: 992px)')
         .pipe(takeUntil(this.destroy$))
         .subscribe((result) => {
            this.isMobile = result.matches;
         });
   }

   ngOnChanges(changes: SimpleChanges): void {
      if (
         this.musaffaSectorName &&
         this.marketCapClassification &&
         this.country
      ) {
         // this.stocksRelated(
         //    this.musaffaSectorName,
         //    this.country,
         //    this.gsubind,
         //    this.ticker,
         //    this.gsector,
         //    this.finnhubIndustry,
         //    this.musaffaIndustryName,
         // );

         this.fetchRelatedStocks(this.ticker, this.country, this.gsubind)
      }
   }

   ngOnDestroy(): void {
      if (this.subscriptions && this.subscriptions.length > 0) {
         this.subscriptions.forEach((item) => {
            item.unsubscribe();
         });
      }
   }
   private relatedStocksCache = new Map<string, any>();

   private getCacheKey(ticker: string, country: string, gsubind: string): string {
      return `${ticker}-${country}-${gsubind}`;
   }

   private fetchRelatedStocks(ticker: string, country: string, gsubind: string) {
      this.loader = true;
      const symbols: any[] = [];
      const cacheKey = this.getCacheKey(ticker, country, gsubind);

      // Check cache first
      if (this.relatedStocksCache.has(cacheKey)) {
         const cachedData = this.relatedStocksCache.get(cacheKey);
         this.relatedStocks = cachedData.relatedStocks;
         this.getData(cachedData.tickersArr);
         this.complianceInfo = cachedData.complianceInfo;
         this.loader = false;
         return;
      }

      this.apiService.getRelatedStocks(ticker, country, gsubind)
         .then(async data => {
            this.relatedStocks = data.hits.map(
               (obj: any) => {
                  const item: any = obj.document;
                  const stockObj = {
                     type: 'STOCK',
                     identifier: item.identifier,
                     stockName: item.ticker,
                     companyName: item.name,
                     currentPrice: item.currentPrice,
                     percentChange: item.percentChange,
                     isin: item.isin,
                     shariahCompliantStatus: item.shariahCompliantStatus,
                     compliantRanking: item.compliantRanking,
                     ranking_v2: item.ranking_v2,
                     currency: item.currency,
                     logo: item.logo,
                     ticker: item.ticker,
                     usdMarketcap: item.usdMarketCap,
                     marketcap: item.marketcap
                  };
                  return stockObj;
               }
            );

            let tickersArr = this.relatedStocks.map(
               (obj: any) => obj.stockName
            );

            const complianceInfo = await this.collectionCompliance.getAccessibleComplianceInfo(symbols, 'stocks');

            // Cache the results
            this.relatedStocksCache.set(cacheKey, {
               relatedStocks: this.relatedStocks,
               tickersArr,
               complianceInfo
            });

            this.getData(tickersArr);
            this.complianceInfo = complianceInfo;
            this.loader = false;
         });
   }

   // private stocksRelated(
   //    musaffaSectorName: string,
   //    // marketCapClassification: string,
   //    country: string,
   //    gsubind: string,
   //    ticker: string,
   //    gsector: string,
   //    finnhubIndustry: string,
   //    musaffaIndustryName: string | undefined
   // ) {
   //    this.loader = true;
   //    // const sectorToUse = musaffaSectorName ? `musaffaSectorName:=${musaffaSectorName}` : `gsector:=${gsector}`;
   //    // const industryToUse = musaffaIndustryName ? `musaffaIndustryName:=${musaffaIndustryName}` : `finnhubIndustry:=${finnhubIndustry}`;

   //    const sectorToUse = `gsector:=${gsector}`;
   //    const industryToUse = `finnhubIndustry:=${finnhubIndustry}`;

   //    var filterQuery = `tickerIsMain:=true&&country:=${country}&&${sectorToUse}&&${industryToUse}&&exchange:!=OTC&&ticker:!=${ticker}&&shariahCompliantStatus:=COMPLIANT&&status:=PUBLISH`;

   //    let requestParams = {
   //       q: '*',
   //       filter_by: filterQuery,
   //       sort_by: 'usdMarketCap:desc',
   //       per_page: '15',
   //       page: '1',
   //    };
   //    const symbols: any[] = [];
   //    this.typesenseService
   //       .getRelatedStocks(requestParams)
   //       .then((data: any) => {

   //          this.relatedStocks = data.hits.map(
   //             (obj: any, index: any, arr: any) => {
   //                const item: any = obj.document;
   //                symbols.push(item.isin);
   //                return {
   //                   type: 'STOCK',
   //                   identifier: item.identifier,
   //                   stockName: item.ticker,
   //                   companyName: item.name,
   //                   currentPrice: item.currentPrice,
   //                   percentChange: item.percentChange,
   //                   isin: item.isin,
   //                   shariahCompliantStatus: item.shariahCompliantStatus,
   //                   compliantRanking: item.compliantRanking,
   //                   currency: item.currency,
   //                   logo: item.logo,
   //                };
   //             }
   //          );

   //          let tickersArr = this.relatedStocks.map((obj:any)=>obj.stockName)
   //          this.getData(tickersArr);
   //          this.loader = false
   //       })
   //       .finally(async () => {
   //          this.complianceInfo =
   //             await this.collectionCompliance.getAccessibleComplianceInfo(
   //                symbols,
   //                'stocks'
   //             );
   //       });
   // }

   getData(symbols: string[]) {
      this.typesenseService.getPrices(symbols).then((res) => {
         for (const key in res) {
            let priceValue = res[key];
            let index = this.relatedStocks.findIndex(
               (item: any) => item.stockName == key
            );
            if (!!this.relatedStocks[index]) {
               if (!this.relatedStocks[index].lastPrice) {
                  this.relatedStocks[index].lastPrice = priceValue.currentPrice;
               }
               this.relatedStocks[index].price = priceValue.currentPrice;
               this.relatedStocks[index].currentPrice = priceValue.currentPrice;
               this.relatedStocks[index].priceChange =
                  priceValue.change.toFixed(2);
               this.relatedStocks[index].priceChangePercent =
                  priceValue.percentChange.toFixed(2);
               this.relatedStocks[index].percentChange =
                  priceValue.percentChange.toFixed(2);
            }
            // console.log(priceValue)
            // console.log(this.relatedStocks[index])
         }
      });
   }

   orderList(fieldName: string) {
      if (this.orderFieldName === fieldName) {
         this.orderDirection = !this.orderDirection;
      } else {
         this.orderFieldName = fieldName;
      }
   }
   checkRole(role: string): boolean {
      return this.auth.checkRole(role);
   }

   public request(stockName: string, companyName: string) {
      this.loader = true;
      let subscription = this.apiService
         .requestAnalitcs(stockName, companyName)
         .subscribe((data: any) => {
            this.showRequest = true;
            this.loader = false;
         });
      this.subscriptions.push(subscription);
   }

   sortBy(colName: string, boolean: boolean) {
      if (boolean == true) {
         this.relatedStocks.sort((a, b) =>
            a[colName] < b[colName] ? 1 : a[colName] > b[colName] ? -1 : 0
         );
         this.booleanValue = false;
      } else {
         this.relatedStocks.sort((a, b) =>
            a[colName] > b[colName] ? 1 : a[colName] < b[colName] ? -1 : 0
         );
         this.booleanValue = true;
      }
   }

   transformValue(value: any) {
      return Math.abs(value);
   }

   getPercentChangeClasses(change: any) {
      return {
         positive: change >= 0,
         negative: change < 0,
      };
   }

   getIconClasses(change: any) {
      return {
         'bi-caret-up-fill positive': change >= 0,
         'bi-caret-down-fill negative': change < 0,
      };
   }
}
